<template>
  <div class="register-page">
    <div class="register-shell">
      <div class="brand-corner">
        <img class="brand-corner-logo" :src="pageLogo" alt="COG" @click="goHome()"/>
      </div>

      <div class="register-stage">
        <div class="stage-visual">
          <img class="stage-visual-img" :src="stageImage" alt="注册主视觉" />
        </div>

        <section class="register-card">
          <img class="register-card-logo" :src="cardLogo" alt="COG" />

          <div class="register-tabs">
            <button
              type="button"
              :class="['register-tab', { active: activeType === 'org' }]"
              @click="switchRegisterType('org')"
            >
              <img :src="activeType === 'org' ? orgTabIconActive : orgTabIcon" alt="MCN机构" class="register-tab-icon" />
              <span>MCN机构</span>
            </button>
            <button
              type="button"
              :class="['register-tab', { active: activeType === 'personal' }]"
              @click="switchRegisterType('personal')"
            >
              <img :src="activeType === 'personal' ? personalTabIconActive : personalTabIcon" alt="个人主播" class="register-tab-icon" />
              <span>个人主播</span>
            </button>
          </div>

          <el-form ref="registerForm" :model="registerForm" class="register-form" @submit.native.prevent>
            <div v-if="activeType === 'org'" class="form-block">
              <div class="field-label">企业名称 <span class="required">*</span></div>
              <el-input v-model.trim="registerForm.companyName" placeholder="请输入企业完整名称" class="field-input" />
            </div>

            <div v-if="activeType === 'org'" class="form-block">
              <div class="field-label">统一社会信用代码 <span class="required">*</span></div>
              <el-input v-model.trim="registerForm.creditCode" placeholder="请输入统一社会信用代码" class="field-input" />
            </div>

            <div v-if="activeType === 'personal'" class="form-block">
              <div class="field-label">主播名称 <span class="required">*</span></div>
              <el-input v-model.trim="registerForm.anchorName" placeholder="请输入真实名称" class="field-input" />
            </div>

            <div class="form-block">
              <div class="field-label">手机号 <span class="required">*</span></div>
              <el-input v-model.trim="registerForm.mobile" maxlength="11" placeholder="请输入手机号" class="field-input" />
            </div>

            <div class="form-block">
              <div class="field-label">图形验证码 <span class="required">*</span></div>
              <div class="inline-row2">
                <el-input v-model.trim="registerForm.imageCode" maxlength="6" placeholder="请输入验证码" class="field-input flex-1" />
                <button type="button" class="captcha-box" @click="refreshCaptcha" title="点击刷新验证码">
                  <img v-if="captchaImage" :src="captchaImage" alt="图形验证码" class="captcha-image" />
                  <span v-else>加载中</span>
                </button>
              </div>
            </div>

            <div class="form-block">
              <div class="field-label">验证码 <span class="required">*</span></div>
              <div class="inline-row">
                <el-input v-model.trim="registerForm.smsCode" maxlength="6" placeholder="请输入验证码" class="field-input flex-1" />
                <button type="button" class="code-btn" :disabled="smsLoading || countdown > 0" @click="handleSendSmsCode">
                  {{ countdown > 0 ? `${countdown}s后重试` : '获取验证码' }}
                </button>
              </div>
            </div>

            <div class="agreement-block">
              <label v-if="activeType === 'org'" class="agreement-item">
                <input v-model="registerForm.agreeService" type="checkbox" />
                <span>
                  注册需要同意并接受
                  <button type="button" class="agreement-link" @click="openAgreement('register')">《用户服务协议》</button>
                  <!-- <button type="button" class="agreement-link" @click="openAgreement('platform')">《平台管理公约》</button> -->
                </span>
              </label>

              <label v-if="activeType === 'org'" class="agreement-item">
                <input v-model="registerForm.agreeMarketing" type="checkbox" />
                <span>同意同步注册天府信用通</span>
              </label>

              <label v-if="activeType === 'personal'" class="agreement-item">
                <input v-model="registerForm.agreeService" type="checkbox" />
                <span>
                  注册平台账号代表您同意平台
                  <button type="button" class="agreement-link" @click="openAgreement('register')">《用户服务协议》</button>
                  <!-- 、
                  <button type="button" class="agreement-link" @click="openAgreement('privacy')">《隐私协议》</button> -->
                </span>
              </label>
            </div>

            <button type="button" class="submit-btn" :disabled="submitting" @click="handleSubmitRegister">
              {{ submitting ? '注册中...' : '注册' }}
            </button>
          </el-form>

          <div class="register-footer">
            <span>已有账号？</span>
            <button type="button" class="login-link" @click="goLogin">立即登录</button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { getCaptcha, sendAuthSmsCode, registerAccount } from '@/api/user';

export default {
  name: 'register',
  data() {
    return {
      activeType: 'org',
      smsLoading: false,
      submitting: false,
      countdown: 0,
      countdownTimer: null,
      captchaKey: '',
      captchaImage: '',
      pageLogo: require('../../assets/img/login/l_logo2.png'),
      cardLogo: require('../../assets/img/login/l_logo.png'),
      pageBackground: require('../../assets/img/login/l_bg.png'),
      stageImage: require('../../assets/img/login/bo.png'),
      orgTabIcon: require('../../assets/img/login/jg.png'),
      orgTabIconActive: require('../../assets/img/login/jgxz.png'),
      personalTabIcon: require('../../assets/img/login/gr.png'),
      personalTabIconActive: require('../../assets/img/login/grxz.png'),
      registerForm: {
        companyName: '',
        creditCode: '',
        anchorName: '',
        mobile: '',
        smsCode: '',
        imageCode: '',
        agreeService: false,
        agreeMarketing: false
      }
    };
  },
  mounted() {
    this.refreshCaptcha();
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  },
  methods: {
    switchRegisterType(type) {
      this.activeType = type;
      this.registerForm.smsCode = '';
      this.registerForm.imageCode = '';
      this.refreshCaptcha(true);
    },
    goLogin() {
      this.$router.push({ path: '/login' });
    },
    openAgreement(type) {
      void type;
      // this.$message.info('协议内容接口待接入');
	  window.open('https://cogapi.scszsj.com/service.html');
    },
    async refreshCaptcha(silent = false) {
      try {
        const response = await getCaptcha();
        this.captchaKey = response && response.key ? response.key : '';
        this.captchaImage = response && response.img ? response.img : '';
      } catch (error) {
        this.captchaKey = '';
        this.captchaImage = '';
        if (!silent) {
          this.$message.warning(error && error.message ? error.message : '图形验证码加载失败');
        }
      }
    },
    validateBaseFields(requireServiceAgreement = false) {
      if (this.activeType === 'org' && !this.registerForm.companyName) {
        this.$message.warning('请输入企业名称');
        return false;
      }

      if (this.activeType === 'org' && !this.registerForm.creditCode) {
        this.$message.warning('请输入统一社会信用代码');
        return false;
      }

      if (this.activeType === 'personal' && !this.registerForm.anchorName) {
        this.$message.warning('请输入主播名称');
        return false;
      }

      if (!/^1\d{10}$/.test(this.registerForm.mobile)) {
        this.$message.warning('请输入正确的手机号');
        return false;
      }

      if (requireServiceAgreement && !this.registerForm.agreeService) {
        this.$message.warning('请先阅读并同意相关协议');
        return false;
      }

      return true;
    },

    validateCaptchaFields() {
      if (!this.captchaKey || !this.captchaImage) {
        this.$message.warning('图形验证码加载失败，请刷新后重试');
        return false;
      }

      if (!this.registerForm.imageCode) {
        this.$message.warning('请输入图形验证码');
        return false;
      }

      return true;
    },
    startSmsCountdown() {
      this.countdown = 60;
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.countdownTimer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    async handleSendSmsCode() {
      if (!this.validateBaseFields() || !this.validateCaptchaFields()) {
        return;
      }

      this.smsLoading = true;
      try {
        await this.requestRegisterSmsCode();
        this.$message.success('验证码已发送');
        this.startSmsCountdown();
        //this.registerForm.imageCode = '';
       // await this.refreshCaptcha(true);
      } catch (error) {
        this.$message.warning(error && error.message ? error.message : '验证码发送失败');
        if (this.isCaptchaError(error)) {
          this.registerForm.imageCode = '';
          await this.refreshCaptcha(true);
        }
      } finally {
        this.smsLoading = false;
      }
    },
    async handleSubmitRegister() {
      if (!this.validateBaseFields(true)) {
        return;
      }

      if (!this.registerForm.smsCode) {
        this.$message.warning('请输入短信验证码');
        return;
      }

      this.submitting = true;
      try {
        const result = this.activeType === 'org'
          ? await this.registerAsOrg()
          : await this.registerAsPersonal();

        this.handleRegisterSuccess(result);
      } catch (error) {
        this.$message.warning(error && error.message ? error.message : '注册失败');
      } finally {
        this.submitting = false;
      }
    },

    async requestRegisterSmsCode() {
      return sendAuthSmsCode({
        phone: this.registerForm.mobile,
        scene: 'register',
        captcha_key: this.captchaKey,
        captcha_code: this.registerForm.imageCode
      });
    },

    async registerAsOrg() {
      return registerAccount({
        type: 'mcn',
        name: this.registerForm.companyName,
        phone: this.registerForm.mobile,
        code: this.registerForm.smsCode,
        company_code: this.registerForm.creditCode,
        sync_credit: this.registerForm.agreeMarketing
      });
    },

    async registerAsPersonal() {
      return registerAccount({
        type: 'individual',
        name: this.registerForm.anchorName,
        phone: this.registerForm.mobile,
        code: this.registerForm.smsCode
      });
    },
	goHome(){
		this.$router.push({
		  path: '/'
		});
	},
    isCaptchaError(error) {
      const errors = error && error.data && error.data.errors;
      return Boolean(errors && errors.captcha_code)
        || (error && error.message ? error.message.includes('图形验证码') : false);
    },
    handleRegisterSuccess(response) {
      const token = response && response.token;
      if (!token) {
        throw new Error('注册返回数据不完整');
      }

      const userInfo = response && response.data;
      const userType = userInfo && userInfo.type
        ? userInfo.type
        : (this.activeType === 'org' ? 'mcn' : 'individual');

      localStorage.setItem('token', token);
      localStorage.setItem('loginType', userType);
      if (userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
      }
      if (this.$store) {
        this.$store.commit('user/SET_TOKEN', token);
      }

      this.$message.success((response && response.message) || '注册成功');
      this.$router.push({
        path: userType === 'mcn' || userType === 'org' ? '/user/org' : '/user/personal'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.register-page {
  min-height: 100vh;
  background: url('../../assets/img/login/l_bg.png') center no-repeat;
  background-size: 100% 100%;
}

.register-shell {
  position: relative;
  min-height: 100vh;
  padding: 30px 52px;
}

.brand-corner {
  position: absolute;
  top: 32px;
  left: 52px;
  cursor: pointer;
}

.brand-corner-logo {
  width: 292px;
  display: block;
}

.register-stage {
  min-height: calc(100vh - 60px);
  display: grid;
  grid-template-columns: minmax(480px, 1fr) 536px;
  align-items: center;
  gap: 72px;
}

.stage-visual {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-top: 30px;
}

.stage-visual-img {
  width: min(100%, 540px);
  display: block;
  transform: translateX(-90px);
}

.register-card {
  width: 536px;
  min-height: 692px;
  padding: 58px 48px 38px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 20px 60px rgba(131, 141, 190, 0.18);
  transform: translateX(-270px);
}

.register-card-logo {
  width: 152px;
  display: block;
  margin: 0 auto;
}

.register-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 38px;
  border-bottom: 1px solid #cfd3de;
   width: 260px;
}

.register-tab {
  height: 44px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #8a93b3;
  font-size: 16px;
  cursor: pointer;
}

.register-tab.active {
  border-bottom-color: #6575ff;
  color: #6575ff;
}

.register-tab-icon {
  width: 16px;
  height: 16px;
  display: block;
  object-fit: contain;
}

.register-form {
  margin-top: 22px;
}

.form-block {
  margin-top: 20px;
}

.field-label {
  margin-bottom: 8px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #1E293B;
  line-height: 20px;
}

.required {
  color: #D06BF7;
}

.inline-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 118px;
  gap: 10px;
  align-items: center;
}

.inline-row2 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 87px;
  gap: 10px;
  align-items: center;
  height: 45px;
  background: #F8FAFC;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  color: #2d3654;
  font-size: 15px;
}

.flex-1 {
  min-width: 0;
}

.field-input ::v-deep .el-input__inner {
  height: 45px;
  border-radius: 10px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  color: #2d3654;
  font-size: 15px;
}

.field-input ::v-deep .el-input__inner::placeholder {
  color: #b2b9d0;
}

.field-input ::v-deep .el-input__inner:focus {
  border-color: #7a83ff;
}

.code-btn,
.captcha-box {
  height: 46px;
  border: 0;
  border-radius: 8px;
}

.code-btn {
  cursor: pointer;
  background: #E6E9FF;
   font-size: 14px;
   cursor: pointer;
   font-family: Source Han Sans, Source Han Sans;
   font-weight: 400;
   font-size: 14px;
   color: #4F46E5;
}

.code-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.captcha-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
  border: none;
  background: none;
  cursor: pointer;
  width: 82px;
  height: 36px;
  margin-top: 0;
}

.captcha-image {
  width: 100%;
  height: 100%;
  display: block;
}

.agreement-block {
  margin-top: 18px;
}

.agreement-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 12px;
  color: #3D3D3D;
  line-height: 18px;
}

.agreement-item input {
  margin-top: 3px;
}

.agreement-link {
  border: 0;
  padding: 0;
  background: transparent;
  color: #4d79ff;
  font-size: 13px;
  cursor: pointer;
}

.submit-btn {
  width: 100%;
  height: 54px;
  margin-top: 22px;
  border: 0;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  background: linear-gradient( 117deg, #518BFF 0%, #9E5DFF 100%), linear-gradient( 149deg, rgba(172,234,255,0.6) 0%, rgba(209,250,255,0) 100%);
  box-shadow: 0px 2px 10px 0px rgba(157,157,191,0.35);
  border-radius: 12px 12px 12px 12px;
}

.submit-btn:disabled {
  cursor: not-allowed;
  opacity: 0.75;
}

.register-footer {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #999FB8;
  line-height: 20px;
}

.login-link {
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #4F46E5;
}

@media (max-width: 1200px) {
  .register-shell {
    padding: 24px;
  }

  .brand-corner {
    left: 24px;
    top: 24px;
  }

  .register-stage {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 24px;
    padding-top: 70px;
  }

  .stage-visual {
    padding-top: 0;
  }

  .stage-visual-img,
  .register-card {
    transform: none;
  }
}

@media (max-width: 640px) {
  .brand-corner-logo {
    width: 210px;
  }

  .register-card {
    min-height: auto;
    padding: 34px 20px 28px;
    border-radius: 20px;
  }

  .register-card-logo {
    width: 170px;
  }

  .register-tab {
    font-size: 14px;
  }

  .field-label {
    font-size: 14px;
  }

  .inline-row {
    grid-template-columns: 1fr;
  }

  .code-btn,
  .captcha-box,
  .field-input ::v-deep .el-input__inner {
    height: 44px;
  }
}
</style>
